import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormGroupService {

  constructor(private builder: FormBuilder) { }

  getMonitorowaniePodmiotuGroup(): FormGroup {
    return this.builder.group({
      subskrypcjaOd: [null, [Validators.required]],
      subskrypcjaDo: [null, [Validators.required]],
      powiadomienieEmail: [true, []],
      przedlozORok: [true, []],
      nazwaPodmiotuSub: [null]
    });
  }

  getPowiadomienieGroup(): FormGroup {
    return this.builder.group({
      numerKRS: [null],
      dataZdarzenia: [null],
    });
  }

  getWyszukiwarkaForm(): FormGroup {
    return this.builder.group({
      rodzajRejestru: [null, [Validators.required]],
      encryptedKrs: [null]
    })
  }
}
